<template>
  <div class="PrintAudit">
    <el-dialog
      :title="row && row.applyType === 1 ? '证书套打审核' : '证书补打审核'"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="handleClose">
      {{row && row.applyType === 1 ? '证书套打说明' : '证书补打说明'}}: {{msg}}
      <el-table v-if="dialogVisible" ref="multipleTable" style="margin-top: 10px" border :data="list">
        <el-table-column align="center" label="班级名称" prop="skuName" width=""></el-table-column>
        <el-table-column align="center" label="已绑定证书" prop="certificateNo" width=""></el-table-column>
        <el-table-column align="center" label="所属项目" prop="projectName" width=""></el-table-column>
        <el-table-column align="center" label="考场名称" prop="examTitle" width=""></el-table-column>
        <el-table-column align="center" label="用户昵称" prop="name" width=""></el-table-column>
        <el-table-column align="center" label="用户电话" prop="phone" width=""></el-table-column>
        <el-table-column align="center" label="合格证套打状态" prop="" width="">
          <template slot-scope="scope">
            <template >
              <span v-if="scope.row.printState === 1">未套打</span>
              <span v-if="scope.row.printState === 2">补打</span>
              <span v-if="scope.row.printState === 3">已套打</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" prop="" width="">
          <template slot-scope="scope">
            <a v-if="row.applyType !== 1" href="javascript:;" @click="$refs.PrintMsg.init(scope.row)">查看补打说明</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="$refs.AuditRejected.init()">审核驳回</el-button>
        <el-button type="primary" size="small" @click="audit(2)">审核通过</el-button>
      </span>
    </el-dialog>

    <AuditRejected ref="AuditRejected" @close="close" />
    <PrintMsg ref="PrintMsg"/>
  </div>
</template>

<script>
import { getListPageAudit, printApplyAudit } from "@/api/certificate/index";
import AuditRejected from './AuditRejected.vue'
import PrintMsg from './PrintMsg.vue'
export default {
  name: 'PrintAudit',
  components: { AuditRejected, PrintMsg },
  data () {
    return {
      dialogVisible: false,
      filter: {
        page: 1,
        limit: 10,
        printApplyId: ''
      },
      list: [],
      total: 0,
      msg: '',
      row: null,
      // 驳回原因 
      rejectReason: ''
    }
  },
  methods: {
    init(row) {
      this.filter.printApplyId = row.id
      this.msg = row.applyType === 1 ? row.applyExplain : row.repairPrintExplain
      this.row = row
      this.getListPageAudit()
      this.dialogVisible = true
    },
    async getListPageAudit() {
      const res = await getListPageAudit(this.filter)
      this.list = res.data.records
      this.total = +res.data.total
    },
    close(rejectReason) {
      this.rejectReason = rejectReason
      this.audit(3)
    },
    async audit(auditState) {
      const res = await printApplyAudit({ ids: this.row.id, auditState, rejectReason: this.rejectReason })
      this.$message.success('操作成功')
      this.handleClose()
      this.$parent.search()
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.PrintAudit {

}
</style>
